import React from 'react'

import checkmarkActive from '../../../images/checkmark-active.png'
import sweeperTrophy from '../../../images/sweeper-trophy.png'
import redCross from '../../../images/red-cross.png'

const ChartGeneralStats = ({ chart }) => {
  const rowStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  }

  const { wins, activeMistakes, fixedMistakes } = chart

  const activeMistakesCount = Object.values(activeMistakes).reduce(
    (acc, curr) => {
      return parseInt(acc) + parseInt(curr)
    },
    [0],
  )

  const fixedMistakesCount = Object.values(fixedMistakes).reduce(
    (acc, curr) => {
      return parseInt(acc) + parseInt(curr)
    },
    [0],
  )

  return (
    <div
      style={{
        ...rowStyle,
        justifyContent: 'space-between',
        marginTop: '20px',
        display: 'flex',
      }}
    >
      <div style={rowStyle}>
        <img
          alt="trophy"
          src={sweeperTrophy}
          style={{
            height: 19,
            width: 24,
          }}
        />
        <div
          className="ClearTheCharts__stats-label"
          style={{
            fontSize: '14px',
            marginLeft: '8px',
          }}
        >
          Wins: {wins}
        </div>
      </div>
      <div style={rowStyle}>
        <img
          alt="checkmark"
          src={checkmarkActive}
          style={{
            height: 19,
            width: 19,
          }}
        />
        <div
          className="ClearTheCharts__stats-label"
          style={{
            fontSize: '14px',
            marginLeft: '8px',
          }}
        >
          Fixed: {fixedMistakesCount}
        </div>
      </div>
      <div style={rowStyle}>
        <img
          alt="mistake"
          src={redCross}
          style={{
            height: 19,
            width: 19,
          }}
        />
        <div
          className="ClearTheCharts__stats-label"
          style={{
            fontSize: '14px',
            marginLeft: '8px',
          }}
        >
          Active: {activeMistakesCount}
        </div>
      </div>
    </div>
  )
}

export default ChartGeneralStats
